import types from "../types/auth";

const emptyInitialState: any = {
  auth: {
    value: null,
    loading: false,
    loaded: false,
  },
};

const initialState = emptyInitialState;

export const userReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case types.USER_TOKEN: {
      // Puede llegar sin payload cuando hay token guardado pero no datos de usuario:
      // antes rompia la app en cada carga y dejaba la pantalla bloqueada.
      const user = action.payload?.user ?? null;     
      return {
        ...state,
        can_access: true,
        user,
      };
    }
    case types.auth.default: {
      return {
        ...state,
        auth: { ...state.auth, loading: true },
      };
    }
    case types.auth.success: {
      return {
        ...state,
        auth: {
          ...state.auth,
          value: action.payload?.results || [],
          loading: false,
          loaded: true,
        },
      };
    }
    case types.auth.fail: {
      return {
        ...state,
        auth: {
          ...state.auth,
          loading: false,
          loaded: false,
          value: emptyInitialState.auth.value,
        },
      };
    }
    default:
      return state;
  }
};
